import styled from '@emotion/styled'

export default styled.div`
  position: absolute;
  margin-top: -5rem;
`